<template>
  <linkable-item as="router-link" :to="`/showcase/${collection.uid}?collectionId=${collection.id}`">
    <div class="collection-item">
      <img v-if="collection.photoUrl" v-lazy="{ src: collection.photoUrl }" />

      <div v-else-if="collection.displayName" class="letter-wrapper">
        {{ collection.displayName[0].toUpperCase() }}
      </div>

      <div v-else class="letter-wrapper">
        <icon name="person" />
      </div>

      <div class="collection-item-content">
        <div class="collection-name">
          {{ collection.name }}
        </div>

        <p class="bottom-row">
          <span class="display-name">{{ collection.displayName }}</span>

          <stat-item
            label="Num Cards"
            :value="$filters.number(collection.totalNumCards)"
          />
        </p>
      </div>
    </div>
  </linkable-item>
</template>

<script>
import LinkableItem from '@cardladder/shared/components/LinkableItem';
import StatItem from '@cardladder/shared/components/StatItem';

export default {
  components: {
    LinkableItem,
    StatItem,
  },

  props: {
    collection: Object,
  },
};
</script>

<style lang="scss" scoped>
.collection-item {
  width: 100%;
  display: flex;
  padding: $gp 0 0 $gp;

  img {
    object-fit: cover;
  }

  .letter-wrapper,
  img {
    width: 100px;
    height: 100px;
    margin-right: $gp;
    border-radius: $border-radius;
    margin-bottom: $gp;
    box-shadow: $elevation-1;
  }

  .letter-wrapper {
    background-color: $color-gray-5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    --icon-size: 60px;
    font-weight: bold;
  }

  .collection-item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    border-bottom: solid 1px var(--theme-border);
    padding: 0 $gp $gp 0;
  }

  .collection-name {
    margin-bottom: $gp * .5;
    font-size: 24px;

    @media($medium-down) {
      font-size: 18px;
    }
  }

  .bottom-row {
    margin-top: auto;
    margin-bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;

    > * {
      margin-top: $gp * .25;
    }
  }

  .display-name {
    padding-bottom: 3px;
  }
}
</style>
